import '../../../shared/brand.css';

/** Shared brand geometry; adjacent text supplies the accessible brand name. */
export function BrandMark({ className = '' }: { className?: string }) {
  return <img className={`becoder-brand-icon ${className}`.trim()} src="/brand/bixing-20261102/icon.svg" width="32" height="32" alt="" aria-hidden="true" decoding="async" />;
}
